import React from 'react';
import ViewBrandsComponent from '../../../Components/Brands/ViewBrands';

export default function ViewBrands() {
    return (
        <div className='page-body'>
            <ViewBrandsComponent />
        </div>
    );
}